import { render, staticRenderFns } from "./identityTag.vue?vue&type=template&id=39dc0b36&scoped=true"
import script from "./identityTag.vue?vue&type=script&lang=js"
export * from "./identityTag.vue?vue&type=script&lang=js"
import style0 from "./identityTag.vue?vue&type=style&index=0&id=39dc0b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc0b36",
  null
  
)

export default component.exports